import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-select-list',
  templateUrl: './select-list.fragment.html',
  styleUrls: [
    './select-list.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SelectListFragment implements OnInit {

  public validButtonLabel = 'Valider';

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeSelectList();
    }
  }

  @Output() public closeEmitter = new EventEmitter();

  public header: string;
  public errorMessage: string;
  public selectedData: any;
  public data: any[] = [];
  public dataBodyTable = {
    page: 1,
    perpage: -1,
    total: 0,
    objects: []
  };
  public dataColumnTable: any[] = [];
  public searchObject?: any;
  public searchFunction?: (object: any, filtres: Filtres) => Promise<Paginated<any>>;
  isLoadingTable = false;

  constructor(
    private _modal: ModalService,
    private _view: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this.dataBodyTable.objects = this.data;
  }

  public sendValueSelected() {
    if (this.selectedData) {
      this.closeEmitter.emit(this.selectedData);
    } else {
      this._modal.openAlert(this._view, 'Erreur', this.errorMessage);
    }
  }

  public selectedValue(event: any) {
    if (this.selectedData === event) {
      this._doSelectValue({ doSelect: false, valueId: event.id });
      this.selectedData = undefined;
    } else {
      if (this.selectedData) {
        this._doSelectValue({ doSelect: false, valueId: this.selectedData.id });
      }
      this.selectedData = event;
      this._doSelectValue({ doSelect: true, valueId: event.id });
    }
  }

  private _doSelectValue(value: any): void {
    if (this.dataBodyTable && this.dataBodyTable.objects) {
      const index = this.dataBodyTable.objects.findIndex(p => p.id === value.valueId);
      const valueDisplayTable = this.dataBodyTable.objects.find(p => p.id === value.valueId);

      if (value.doSelect) {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(valueDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(valueDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }
      this.dataBodyTable.objects.splice(index, 1, valueDisplayTable);
    }
  }

  async changePage(event: any) {
    this.isLoadingTable = true;
    try {
      this.dataBodyTable = await this.searchFunction(this.searchObject, {currentPage: event, perpage: this.dataBodyTable.perpage});
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingTable = false;
    }
  }

  closeSelectList(value?: any) {
    if (value) {
      this.closeEmitter.emit(value);
    } else {
      this.closeEmitter.emit();
    }
  }

  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
